import { PersonInfoInterface } from "../../../common/interfaces/PersonInfoInterface";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { indexedDBService } from "../../../common/utils/indexedDB";

interface Props {
    personInfo: PersonInfoInterface;
    navigate: (route: string) => void;
}

export const handleSubmit = async (props: Props): Promise<void> => {
    const { personInfo, navigate } = props;

    try {
        const voteData = {
            choice: personInfo?.choice || "",
            name: personInfo?.name || "",
            email: personInfo?.email || "",
            company: personInfo?.company || "",
            agreeOnTerms: true,
            timestamp: Date.now(),
        };

        await indexedDBService.saveData(`vote_${Date.now()}`, voteData, false);

        navigate(RouteEnum.THANK_YOU);
    } catch (error) {
        console.error("Failed to save vote data:", error);
    }
};
